import React, { useEffect, useState } from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Checkbox from '@material-ui/core/Checkbox';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import SubdirectionsContainer from 'app/containers/SubdirectionsContainer';
import TextInput from 'app/components/TextInput';
import TextEvents from '../TextEvents';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip'
import { Modal, Select, Input, Radio, Icon, Form, Button, Upload, message } from 'antd';
import { styles, useStyles } from './CreateEvaluationStyles';
import Badge from '@material-ui/core/Badge';

import ApiService from 'app/services/ApiService'
import { fetchTest, clearTest, fetchTestFilters, clearTestFilter } from 'app/actions/TestActions';

import { getTrainingSelect } from "app/actions/TrainingActions";
import { useDispatch, useSelector } from 'react-redux';

const { confirm } = Modal;
const { Option } = Select;
const { TextArea } = Input;

const SelectItem = (name = [], value) => {
    let x = [...new Set(name.map(i => i[value]))];
    x = name.map(i => i[value]);
    return (
        x.map((c, i) => <Option key={i}>{c}</Option>)
    );
}

export default function CreateEvaluation(props) {

    const { siteId } = useSelector(state => state.Auth);

    const classes = useStyles();
    const [description, setDesc] = useState('');
    const [name, setName] = useState('');
    const [subdir, setSubdir] = useState([]);
    const [open, setOpen] = useState(false);
    const [isTest, setTestStatus] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState();
    const [resWorkCycle, setResWorkCycle] = useState({});
    const [questions, setQuestions] = useState([]);
    const [typeQuestion, setTypeQuestion] = useState();
    const [idTraining, setIdTraining] = useState(undefined);
    const dispatch = useDispatch();
    const [time, setTime] = useState();

    const [modal2Visible, setModal2Visible] = useState(false);

    let Actual = [];
    let answers = [];
    let isReady = false;
    let emptyOptions = {};
    let isReadyOptions = false;
    let minTwo = false;
    let Btext = 'Incompleta';
    let isSelected = {};

    const { Dragger } = Upload;

    const [state_, setState_] = useState({
        fileList: [],
        finishedOrError: false,
        uploading: false,
    })

    const { uploading, fileList } = state_;
    const actions = {
        multiple: false,
        onRemove: file => {
            setState_(state => {
                const index = state_.fileList.indexOf(file);
                const newFileList = state_.fileList.slice();
                newFileList.splice(index, 1);
                return {
                    fileList: newFileList,
                };
            });
        },
        beforeUpload: file => {
            setState_(state => ({
                fileList: [...state_.fileList, file],
            }));
            return false;
        },
        fileList,
    };


    const uploadFile = async () => {
        const { fileList } = state_;
        const formData = new FormData();
        fileList.forEach(file => {
            formData.append('file', file);
        });

        setState_({
            uploading: true,
        });
        
        await ApiService.postTestTemplate(formData, resWorkCycle.idTest)
            .then(response => {
                setState_({
                    uploading: false,
                });
                Modal.success({
                    title: `Preguntas guardadas correctamente.`,
                    content: response.testTitle,
                }, props.setTab('1'));
                setModal2Visible(false)
                dispatch(clearTest());
                dispatch(fetchTest({ ...props.formData, subdirection: idSubdirection, EmployeeId: employeeId }));
                dispatch(clearTestFilter());
                dispatch(fetchTestFilters(idSubdirection, employeeId));

            })
            .catch(error => {

                let { data } = error.response;
                Modal.error({
                    title: 'Ops, ocurrio un error',
                    content: `${data.message}`,
                });

                setState_(state => ({
                    fileList: [],
                    finishedOrError: false,
                    uploading: false,
                }));
            })
    }

    const {
        idSubdirection,
        employeeId
    } = useSelector(state => state.Auth.employeeById)


    const findSubdir = (params, item) => {
        let temp = [];
        params.subdirs.forEach(v => {
            if (String(v.idSubdirection) === item.key) temp.push(v);

        });
        setSubdir(temp);
    }

    const {
        trainingSelect,
        //isLoadTrainingSelect
    } = useSelector(state => state.TrainingReducer)



    const optionTraining = trainingSelect.map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>);


    const showConfirm = (type) => {
        confirm({
            title: '¿Guardar Evaluación?',
            content: name,
            okText: 'Guardar',
            cancelText: 'Cancelar',
            onOk() {
                let ids = subdir.map(i => i.idSubdirection);
                return ApiService.setTest({ testTitle: name, testDescription: description, idTraining: idTraining, listSubdirection: ids, testDuration: time[0], TestTotalQuestion: 5 }, 'POST')
                    .then(
                        response => {
                            dispatch(clearTestFilter());
                            dispatch(fetchTestFilters(idSubdirection, employeeId));
                            confirm({
                                title: 'Evaluación guardada correctamente.',
                                content: '¿Desea agregar una nueva pregunta?',
                                okText: 'Agregar pregunta',
                                cancelText: 'Más tarde',
                                onOk() {
                                    setTestStatus(true);
                                    setOpen(true);
                                    setResWorkCycle(response)
                                    addQuestion();
                                },
                                onCancel() {
                                    dispatch(clearTest());
                                    dispatch(fetchTest({ ...props.formData, subdirection: idSubdirection, EmployeeId: employeeId }));
                                    dispatch(clearTestFilter());
                                    dispatch(fetchTestFilters(idSubdirection, employeeId));
                                    props.setTab('1')
                                },
                            });
                        }, error => {
                            Modal.error({
                                title: 'Ops, error de conexión',
                                content: 'Se perdió la conexión de red, intente más tarde.',
                            });
                        }
                    )
            },
            onCancel() { },
        });
    }

    const showSecondaryConfirm = () => {
        confirm({
            title: '¿Guardar pregunta(s)?',
            okText: 'Guardar',
            cancelText: 'Cancelar',
            onOk() {
                return ApiService.setTestQuestionAnswer({ idTest: resWorkCycle.idTest, questions }, 'POST')
                    .then(
                        response => {
                            dispatch(clearTest());
                            dispatch(fetchTest({ ...props.formData, subdirection: idSubdirection, EmployeeId: employeeId }));
                            dispatch(clearTestFilter());
                            dispatch(fetchTestFilters(idSubdirection, employeeId));
                            Modal.success({
                                title: `Preguntas guardadas correctamente.`,
                                content: response.testTitle,
                            }, props.setTab('1'));
                            dispatch(clearTest());
                        }, error => {
                            Modal.error({
                                title: 'Ops, error de conexión',
                                content: 'Se perdió la conexión de red, intente más tarde.',
                            });
                        }
                    )
            },
            onCancel() { },
        });
    }

    /*     const findSubdir = (params, item) => {
            let temp = [];
            params.subdirs.forEach(v => {
                if (String(v.idSubdirection) === item.key) temp.push(v);
    
            });
            setSubdir(temp);
        } */

    const addQuestion = () => {
        const key = questions.length <= 0 ? 0 : questions.length;
        questions.find(i => {
            return i.activeKey.isActive = false;
        });
        let question = [...new Set(questions.concat({
            questionDescription: '',
            idQuestionType: 1,
            isEvaluative: false,
            listAnswers: [
                { id: 0, type: 'radio', descriptionAnswer: '', checked: false, isCorrect: true, isApplyComment: false },
                { id: 1, type: 'radio', descriptionAnswer: '', checked: false, isCorrect: false, isApplyComment: false }
            ],
            activeKey: { isActive: true, key: key }
        }))];
        setQuestions(question);
        setSelectedIndex([key]);
    }

    const selectedQuestion = (quiz, param, i) => {
        setTestStatus(true)
        setSelectedIndex(undefined)
        const isQuiz = Array.isArray(quiz);
        const typeSelected = typeof param;
        if (isQuiz && typeSelected === 'undefined') {
            questions.find(i => {
                return i.activeKey.isActive = false;
            });
            questions[quiz.length - 1].activeKey.isActive = true;
            setSelectedIndex(quiz.length - 1);
        } else if (typeSelected === 'object') {
            questions.find(i => {
                return i.activeKey.isActive = false;
            });
            questions[i].activeKey.isActive = true;
            setSelectedIndex(i)
        }
    }

    const generateQuestionList = () => {
        const descriptions = questions.find(i => {
            return i.questionDescription === '';
        })
        const answ = questions.find(i => {
            return i.listAnswers.length === 0;
        })
        if (descriptions === undefined && answ === undefined) {
            isReady = true
        }
        return questions.map((param, i) => {
            return (
                <ListItem button className={classes.nested} selected={param.activeKey.isActive} onClick={() => selectedQuestion(questions, param, i)} key={i}>
                    <ListItemIcon>
                        <IconButton edge="end" aria-label="delete" className={classes.icon}>
                            <Icon type="file" style={param.questionDescription === '' ? { color: '#f50057' } : { color: 'inherit' }} />
                        </IconButton>
                    </ListItemIcon>
                    <Badge className={param.questionDescription !== '' ? classes.marginOptions : classes.margin} badgeContent={param.questionDescription !== '' ? 'Agregar opcion' : Btext} children={''} color='secondary'
                        invisible={param.questionDescription !== '' && param.listAnswers.length >= 2}
                    />
                    {param.listAnswers.map(i => {
                        return (
                            <Badge key={i.id} className={classes.marginOptions} badgeContent={'Completar opciones'} children={''} color='secondary'
                                invisible={i.descriptionAnswer !== '' || param.questionDescription === ''}
                            />)
                    })
                    }
                    <ListItemText secondary={param.questionDescription} />
                    <ListItemSecondaryAction>
                        <IconButton onClick={() => removeQuestion(i)} aria-label="delete">
                            <Icon type="delete" style={styles.addButton} />
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
            )
        })
    }

    //quiz methods
    const onChangeQuestion = (value) => {
        questions[selectedIndex].questionDescription = value.target.value;
        setQuestions([...questions])
    }

    const onChangeQuestionType = (e) => {
        const quest = [...questions];
        quest[selectedIndex].idQuestionType = e;
        setQuestions(quest);
        changeOptions(e, 0);
    }

    const changeText = (val, id, i) => {
        const quest = [...questions];
        quest[selectedIndex].listAnswers[i].descriptionAnswer = val;
        setQuestions(quest);
    }


    const changeOptions = (param, index, type) => {
        const quest = [...questions]
        if (questions[selectedIndex].idQuestionType === 1) {
            questions[selectedIndex].listAnswers.map(i => i.isCorrect = false)
            if (quest[selectedIndex].listAnswers[index] !== undefined) {
                quest[selectedIndex].listAnswers[index].isCorrect = !quest[selectedIndex].listAnswers[index].isCorrect;
                setQuestions(quest)
            }
        } else if (index === 0 && param === 1) {
            questions[selectedIndex].listAnswers.map(i => i.isCorrect = false)
            quest[selectedIndex].listAnswers[index].isCorrect = !quest[selectedIndex].listAnswers[index].isCorrect;
            setQuestions(quest)
        } else if (type === 'remove') {
            if (questions[selectedIndex].listAnswers.length === 1) {
                quest[selectedIndex].listAnswers[0].isCorrect = true;
                setQuestions(quest);
            }
            return null;
        } else {
            if (questions[selectedIndex].listAnswers.length === 1) {
                questions[selectedIndex].listAnswers.map(i => i.isCorrect = false)
            }
            quest[selectedIndex].listAnswers[index].isCorrect = !quest[selectedIndex].listAnswers[index].isCorrect;
            setQuestions(quest);
        }
    }

    const removeClick = (i) => {
        const newOptions = [...questions];
        newOptions[selectedIndex].listAnswers.splice(i, 1);
        setQuestions(newOptions)
        changeOptions(typeQuestion, 0, 'remove');
    }
    const removeQuestion = (i) => {
        const newQuestions = [...questions];
        if (newQuestions.length > 1) {
            newQuestions.splice(i, 1);
            const key = newQuestions.length - 1;
            setSelectedIndex([key]);
            newQuestions[key].activeKey.isActive = true;
            setQuestions(newQuestions);
        } else {
            setOpen(false);
            setTestStatus(false);
        }
    }

    const addOptions = (data) => {
        Actual = [...data];
        const index = Actual[selectedIndex].listAnswers.length;
        if (questions[selectedIndex].listAnswers.length === 0) {
            answers.push({ id: index + 1, type: 'radio', descriptionAnswer: '', checked: false, isCorrect: true, isApplyComment: false });
            Actual[selectedIndex].listAnswers.push({ id: index + 1, type: 'radio', descriptionAnswer: '', checked: false, isCorrect: true, isApplyComment: false });
            // Object.values(Actual)
            setQuestions(Actual);
        } else {
            answers.push({ id: index + 1, type: 'radio', descriptionAnswer: '', checked: false, isCorrect: false, isApplyComment: false });
            Actual[selectedIndex].listAnswers.push({ id: index + 1, type: 'radio', descriptionAnswer: '', checked: false, isCorrect: false, isApplyComment: false });
            // Object.values(Actual)
            setQuestions(Actual);

        }
    }

    const addOptionButton = () => {
        return (
            <Form.Item style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px' }}>
                <Button type="primary" onClick={() => addOptions(questions)} >
                    <Icon type="plus" /> Agregar opción
                </Button>
            </Form.Item>
        )
    }

    const createTextArea = () => {
        return (
            selectedIndex >= 0 ? <TextArea
                maxLength={1000}
                value={questions[selectedIndex].questionDescription}
                onChange={e => onChangeQuestion(e, selectedIndex)}
                autosize={{ minRows: 4, maxRows: 5 }}
            /> : '')
    }

    const createOptions = () => {
        const isIndex = typeof selectedIndex !== 'undefined';
        return isIndex ? <Radio.Group className={classes.radioContent} >{questions[selectedIndex].listAnswers.map((param, i) => (
            <div className={classes.flex} key={i}>
                <Radio style={styles.radioStyle} value={param.id} disabled />
                <Input
                    maxLength={1000}
                    id={String(param.id)}
                    value={param.descriptionAnswer}
                    onChange={(e) => changeText(e.target.value, questions[selectedIndex], i)}
                    placeholder='Escribe una opción'
                    className={classes.inputSelect}
                />
                {questions[selectedIndex].listAnswers.length === 1 ? <div className={classes.dynamicDeleteButton} /> : <Tooltip title="Eliminar" placement="top"><IconButton aria-label="delete" onClick={(k) => removeClick(i)}>
                    <Icon className={classes.dynamicDeleteButton}
                        type="minus-circle-o"
                        styles={{ marginRight: '2%' }}
                    />
                </IconButton>
                </Tooltip>}
                <FormGroup >
                    <FormControlLabel
                        control={
                            <Tooltip title="Correcta" placement="top"><Checkbox
                                icon={<Icon type="check" />}
                                checkedIcon={<Icon type="check" className={classes.successIcon} />}
                                value="checkedH"
                                checked={param.isCorrect}
                                className={classes.checkRoot}
                                onChange={() => changeOptions(param, i)}
                            /></Tooltip>
                        }
                        label={param.isCorrect ? 'Respuesta correcta' : ''}
                    />
                </FormGroup>
            </div>
        ))}</Radio.Group> : '';

    }
    const createCheck = (opt) => {
        return questions[selectedIndex].listAnswers.map((item, i) => (
            <div className={classes.radioContent} key={i}>
                <div className={classes.flex} >
                    <Checkbox
                        icon={<Icon type="border" fontSize="small" />}
                        checked={item.checked}
                        value={item.id}
                        color="primary"
                        className={classes.root}
                        disabled
                    />
                    <Input
                        maxLength={1000}
                        id={String(item.id)}
                        value={item.descriptionAnswer}
                        onChange={(e) => changeText(e.target.value, item.id, i)}
                        placeholder='Escribe una opción'
                        className={classes.inputSelect}
                    />
                    {questions[selectedIndex].listAnswers.length === 1 ? <div className={classes.dynamicDeleteButton} /> : <Tooltip title="Eliminar" placement="top"><IconButton aria-label="delete" onClick={(k) => removeClick(i)}>
                        <Icon className={classes.dynamicDeleteButton}
                            type="minus-circle-o"
                            styles={{ marginRight: '2%' }}
                        />
                    </IconButton>
                    </Tooltip>}
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Tooltip title="Correcta" placement="top"><Checkbox
                                    icon={<Icon type="check" />}
                                    checkedIcon={<Icon type="check" className={classes.successIcon} />}
                                    value="checkedH"
                                    checked={item.isCorrect}
                                    className={classes.checkRoot}
                                    onChange={() => changeOptions(item, i)}
                                /></Tooltip>
                            }
                            label={item.isCorrect ? 'Respuesta correcta' : ''}
                        />
                    </FormGroup>
                </div>
            </div>
        ))
    }

    const onChangeRadioGroupType = (e) => {
        const quest = [...questions];
        quest[selectedIndex].idQuestionType = e;
        setQuestions(quest);
    }
    const createTypeButtons = () => {
        return (
            <Radio.Group value={questions[selectedIndex].idQuestionType} onChange={(e) => onChangeRadioGroupType(e.target.value)} style={{ width: '100%', marginBottom: 16 }}>
                <Radio.Button value={1} onClick={() => changeOptions(1, 0)}>Simple</Radio.Button>
                <Radio.Button value={2} onClick={() => changeOptions(2, 0)}>Múltiple</Radio.Button>
            </Radio.Group>
        )
    }

    const testStatus = () => {
        setTestStatus(false)
        questions[selectedIndex].activeKey['isActive'] = false;
    }

    const onChangeNumber = e => {
        const { value } = e.target;
        const reg = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;
        if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
            const val = value.replace(/[^0-9]*/g, '');
            setTime([val])
        }
    };

    useEffect(() => {
        setSubdir([{
            idSubdirection: idSubdirection,
            subdirectionName: "",
            deleted: false
        }])
        dispatch(getTrainingSelect(employeeId));
    }, [dispatch])


    questions.forEach(i => {
        emptyOptions = i.listAnswers.find(i => i.descriptionAnswer === '');
        if (i.listAnswers.length > 0) {
            isSelected = i.listAnswers.find(i => i.isCorrect === true);
        }
    })
    minTwo = questions.find(i => i.listAnswers.length === 1);
    if (emptyOptions === undefined && isSelected !== undefined && minTwo === undefined) {
        isReadyOptions = true
    } else if (typeQuestion === 2 && isSelected === undefined) {
        isReadyOptions = false
    } else {
        isReadyOptions = false
    }
    if (questions[selectedIndex] !== undefined) {
        if (questions[selectedIndex].idQuestionType === 2) {
            const total = questions[selectedIndex].listAnswers.filter(i => i.isCorrect === true)
            if (total.length < 2) {
                isReadyOptions = false
            }
        }

    }
    return (
        <div>
            <Modal
                title="Cargar preguntas por template"
                closable
                destroyOnClose
                visible={modal2Visible}
                onOk={() => uploadFile()}
                onCancel={() => setModal2Visible(false)}
                okButtonProps={{ disabled: fileList?.length == 0, loading: uploading }}
            >

                <Upload {...actions} disabled={siteId !== 'HUB'} accept={'.xlsx'} >
                    <Button>
                        <Icon type="upload" /> Seleccione el archivo...
                    </Button>
                </Upload>
            </Modal>
            <Grid container direction="row">
                <Grid xs={4} item>
                    <Card className={classes.leftCard}>
                        <CardContent>
                            <div>
                                <List
                                    aria-labelledby="nested-list-subheader"
                                    className={classes.principalRoot}
                                    component="nav"
                                    subheader={
                                        <ListSubheader component="div" id="nested-list-subheader">
                                            <div className={classes.iconQ}>
                                                <ListItem button className={classes.justifyContentFlexEnd} onClick={() => addQuestion()} disabled={questions.length <= 0}>
                                                    <ListItemIcon className={classes.iconQ}>
                                                        <Icon style={{ fontSize: '20px', margin: '5%' }} type='plus-circle' theme='twoTone' />
                                                        <TextEvents
                                                            text='Nueva pregunta'
                                                            color='gray'
                                                            size='small'
                                                            weight='regular'
                                                        />
                                                    </ListItemIcon>
                                                </ListItem>
                                                <ListItem button className={classes.justifyContentFlexEnd} disabled={questions.length <= 0} onClick={() => setModal2Visible(true)}>
                                                    <ListItemIcon className={classes.iconQ}>
                                                        <Icon type="file-excel" style={{ fontSize: '20px', margin: '5%', color: '#288504' }} />
                                                        <TextEvents
                                                            text='Cargar template'
                                                            color='gray'
                                                            size='small'
                                                            weight='regular'
                                                        />
                                                    </ListItemIcon>
                                                </ListItem>
                                                <Chip variant="outlined" color="primary" style={{ alignSelf: 'center' }} size="small" label={`Total: ${questions.length}`} disabled={questions.length <= 0} />
                                            </div>
                                        </ListSubheader>
                                    }
                                >
                                </List>
                                <Divider />
                                <List dense={true}>
                                    <ListItem button disabled={!open} selected={!isTest} onClick={testStatus}>
                                        <ListItemIcon className={classes.itemText}>
                                            <IconButton edge="end" aria-label="delete">
                                                <Icon type="folder" />
                                            </IconButton>
                                        </ListItemIcon>
                                        <ListItemText primary={name} className={classes.icon} />
                                        {isTest ? <ListItemSecondaryAction >
                                        </ListItemSecondaryAction> : <div />}
                                    </ListItem>
                                </List>
                                <Collapse in={open} timeout="auto" unmountOnExit className={classes.collapseScroll}>
                                    <List component="div" disablePadding>
                                        {questions.length > 0 ? generateQuestionList() : ''}
                                    </List>
                                </Collapse>
                            </div>
                        </CardContent>
                    </Card>
                </Grid>
                {!isTest ? <Grid xs={8} item>
                    <Card className={classes.card}>
                        <CardContent>
                            <div className={classes.content}>
                                <Grid container direction="row">
                                    <Grid xs={6} item className={classes.gridSeparatorRight}>
                                        <TextInput
                                            value={'-'}
                                            disabled
                                            text='Folio'
                                            mode='input'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                            placeholder=""
                                        >
                                        </TextInput>
                                    </Grid>
                                    <Grid xs={6} item className={classes.gridSeparatorLeft}>
                                        <TextInput
                                            disabled
                                            text='Estatus'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                            mode="multiple"
                                            placeholder="Edición"
                                        >
                                        </TextInput>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextEvents
                                            text='Subdirección Origen'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <SubdirectionsContainer>
                                            {(params) => {
                                                return (
                                                    <Select
                                                        disabled
                                                        placeholder={'Selecciona subdirección'}
                                                        value={subdir.length > 0 ? String(subdir[0].idSubdirection) : null}
                                                        style={{ width: "100%" }}
                                                        onChange={(item) => {
                                                            findSubdir(params, item);
                                                        }}
                                                    >
                                                        {
                                                            params.subdirs.map((item) => {
                                                                return (
                                                                    <Select.Option key={String(item.idSubdirection)} value={String(item.idSubdirection)}>
                                                                        {item.subdirectionName}
                                                                    </Select.Option>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                )
                                            }}
                                        </SubdirectionsContainer>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid item xs={12}>
                                            <TextEvents
                                                text='Tipo de Capacitación'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                            />
                                            <Select
                                                showSearch
                                                placeholder={'Selecciona Tipo de Capacitación'}
                                                //loading={isLoadSystemSpecialty}
                                                value={idTraining}
                                                style={{ width: "100%" }}
                                                onChange={(item) => {
                                                    setIdTraining(item);
                                                    //setIdSystemSpecialty(undefined);
                                                }}
                                                filterOption={(input, option) =>
                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                {optionTraining}
                                            </Select>
                                        </Grid>
                                    </Grid>
                                    <Grid xs={12} item >
                                        <TextInput
                                            disabled={Object.keys(resWorkCycle).length > 0}
                                            value={name}
                                            setValue={setName}
                                            text='Nombre'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                            mode='input'
                                            placeholder='Nombre'
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                            <div>
                                <TextEvents
                                    text='Descripción'
                                    color='darker'
                                    size='label'
                                    weight='medium'
                                />
                                <TextArea
                                    disabled={Object.keys(resWorkCycle).length > 0}
                                    maxLength={1000}
                                    value={description}
                                    onChange={e => setDesc(e.target.value)}
                                    autosize={{ minRows: 5, maxRows: 6 }}
                                    placeholder='Descripción..'
                                />
                                <Grid xs={4} item>
                                    <TextEvents
                                        text={'Tiempo límite (minutos)'}
                                        color='darker'
                                        size='label'
                                        weight='medium'
                                    />
                                    <Input
                                        disabled={Object.keys(resWorkCycle).length > 0}
                                        maxLength={4}
                                        value={time}
                                        placeholder='Tiempo límite'
                                        className={classes.inputSelect}
                                        onChange={onChangeNumber}
                                    />
                                </Grid>
                            </div>
                            <div className={classes.buttonsContainer}>
                                <Button
                                    variant='contained'
                                    type='primary'
                                    onClick={showConfirm}
                                    disabled={Object.keys(resWorkCycle).length > 0 || subdir.length === 0 || name === '' || time === undefined || idTraining === undefined}
                                > Guardar</Button>
                                <Button
                                    type="danger" 
                                    ghost
                                    variant='contained'
                                    className={classes.button}
                                    onClick={() => props.setTab('1')}
                                >Cancelar</Button>
                            </div>
                        </CardContent>
                    </Card>
                </Grid> :
                    <Grid xs={8} item>
                        <Card className={classes.card}>
                            <CardContent>
                                <div className={classes.content}>
                                    <Grid container direction="row">
                                        <Grid xs={12} item className={classes.gridSeparatorTop}>
                                            {typeof questions !== 'undefined' ?

                                                <div>
                                                    {/* AQUI VA EL QUIZ */}
                                                    <Grid container direction="row">
                                                        <Grid xs={12} item className={classes.gridSeparatorRight}>
                                                            <TextEvents
                                                                text='Pregunta'
                                                                color='darker'
                                                                size='label'
                                                                weight='medium'
                                                            />
                                                            {createTextArea()}
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container direction="row">
                                                        <Grid xs={3} item className={classes.gridSeparatorTop}>
                                                            {createTypeButtons()}
                                                        </Grid>
                                                        <Grid xs={9} item >
                                                            {addOptionButton()}
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container direction="row">
                                                        {questions[selectedIndex].idQuestionType === 1 ?
                                                            <Grid xs={12} item >
                                                                {createOptions()}
                                                            </Grid> :
                                                            <Grid xs={12} item >
                                                                {createCheck(questions)}
                                                            </Grid>
                                                        }
                                                    </Grid>
                                                    {/* AQUI CIERRA EL QUIZ */}
                                                </div> : ''}
                                        </Grid>
                                    </Grid>
                                </div>
                            </CardContent>
                        </Card>
                        <div className={classes.buttonsContainer}>
                            <Button
                                variant='contained'
                                type='primary'
                                onClick={showSecondaryConfirm}
                                disabled={questions.length <= 0 || isReady === false || isReadyOptions === false}
                            > Guardar</Button>
                            <Button
                                type="danger" 
                                ghost
                                variant='contained'
                                className={classes.button}
                                onClick={() => props.setTab('1')}
                            >Cancelar</Button>
                        </div>
                    </Grid>}
            </Grid>

        </div>
    );
}